import {Component} from '@angular/core';
import {HttpService} from '../../../services/http.service';
import {AuthService} from "../../../auth/auth.service";


@Component({
  selector: 'app-full-export',
  templateUrl: './full-export.component.html',
  styleUrls: ['./full-export.component.scss']
})
export class FullExportComponent {
  fullExportResponse: string;
  fullExportError: string;

  constructor(private http: HttpService, public authService: AuthService) {
  }

  onClick() {
    this.resetValues();
    this.http.fullExport().subscribe((res: any) => {
      this.fullExportResponse = 'The Full Export Report is being generated and will be written to file.';
    }, error => {
      this.fullExportResponse = 'There was an error generating the report:';
      this.fullExportError = error.message;

    });
  }

  resetValues() {
    this.fullExportError = null;
    this.fullExportResponse = null;
  }
}
